// src/components/PasswordForm.js — choose a password (new users, reset links,
// and Change password in staff and portal Settings). Posts to
// /api/auth/set-password, which updates Supabase Auth and records that the
// password was set (never the password itself). Shared so every path enforces
// the same rules.
import { useState } from 'react'
import api from '../lib/api'

export const MIN_PASSWORD_LENGTH = 8

// centerSubmit: centered, all-caps submit button (set-password screen).
export default function PasswordForm({ submitLabel = 'Update password', onSuccess, successMessage = 'Password updated.', centerSubmit = false }) {
  const [password, setPassword]     = useState('')
  const [confirm, setConfirm]       = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError]           = useState(null)
  const [success, setSuccess]       = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    setError(null)
    setSuccess(false)

    if (password.length < MIN_PASSWORD_LENGTH) {
      return setError(`Password must be at least ${MIN_PASSWORD_LENGTH} characters.`)
    }
    if (password !== confirm) {
      return setError('Passwords do not match.')
    }

    setSubmitting(true)
    try {
      await api.post('/api/auth/set-password', { password })
      setPassword('')
      setConfirm('')
      setSuccess(true)
      if (onSuccess) await onSuccess()
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Could not update password.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14, maxWidth: 380 }}>
      {error && (
        <div role="alert" style={{
          background: 'var(--danger-muted)', border: '1px solid rgba(239,68,68,0.25)',
          borderRadius: 'var(--radius-sm)', padding: '10px 12px', fontSize: 13, color: 'var(--danger-text, #f87171)',
        }}>
          {error}
        </div>
      )}
      {success && !onSuccess && (
        <div role="status" style={{
          background: 'var(--success-muted)', border: '1px solid rgba(16,185,129,0.3)',
          borderRadius: 'var(--radius-sm)', padding: '10px 12px', fontSize: 13, color: 'var(--success-text, #34d399)',
        }}>
          {successMessage}
        </div>
      )}

      <div className="input-group">
        <label className="input-label" htmlFor="new-password">New password</label>
        <input id="new-password" className="input" type="password" autoComplete="new-password"
          value={password} onChange={e => setPassword(e.target.value)} placeholder="At least 8 characters" />
      </div>

      <div className="input-group">
        <label className="input-label" htmlFor="confirm-password">Confirm new password</label>
        <input id="confirm-password" className="input" type="password" autoComplete="new-password"
          value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Repeat it" />
      </div>

      <button type="submit" className="btn btn-primary" disabled={submitting}
        style={centerSubmit
          ? { alignSelf: 'center', textTransform: 'uppercase', letterSpacing: '0.04em' }
          : { alignSelf: 'flex-start' }}>
        {submitting ? 'Saving…' : submitLabel}
      </button>
    </form>
  )
}
